module.exports = __webpack_public_path__ + "static/media/default.7d566673.svg";